import {Text} from '@priority-software/priority-style-react';
import React, {useState, useRef, useEffect} from 'react';
import cx from 'classnames';
import {highlightText} from '../../../../_legacy/library/utils/highlightText';
import styles from './styles.module.scss';
import {createDataTestId} from '../../../../utils/dataTestId';
import {ModernTooltip} from '../../../../components/Common/Tooltip/ModernTooltip';

interface Props {
    value?: string;
    children?: React.ReactNode;
    query: string;
    isDateTime?: boolean;
    isActive: boolean;
    testId: string;
    bold?: boolean;
}

const Item = ({value, query, isDateTime, children, isActive, testId, bold}: Props) => {
    const dataTestId = testId && createDataTestId(`report-list-${testId}`);
    const [isTextTruncated, setIsTextTruncated] = useState(false);
    const textRef = useRef<HTMLDivElement>(null);

    // Check if text is truncated to show tooltip only when needed
    useEffect(() => {
        const checkTruncation = () => {
            if (textRef.current) {
                const isTruncated = textRef.current.scrollWidth > textRef.current.clientWidth;
                setIsTextTruncated(isTruncated);
            }
        };

        checkTruncation();
        // Add resize listener to recheck when window size changes
        window.addEventListener('resize', checkTruncation);
        return () => window.removeEventListener('resize', checkTruncation);
    }, [value]);

    const content = (
        <Text
            fontWeight={bold ? 'bold' : 'normal'}
            componentClasses={cx(styles.text, {
                [styles.ltr]: isDateTime
            })}
            skin="paragraph-2"
            textColor={isActive ? 'primary-700' : 'secondary-300'}
        >
            <div ref={textRef} style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {highlightText(value, query)}
            </div>
        </Text>
    );

    return (
        <div className={cx(styles.tableItem, styles.ellipsis)} {...dataTestId}>
            {children ? (
                children
            ) : isTextTruncated && value ? (
                <ModernTooltip tooltip={value} position="top" wrapperClassname={styles.tooltipWrapper}>
                    {content}
                </ModernTooltip>
            ) : (
                content
            )}
        </div>
    );
};

export default Item;
